import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35abf30a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Code block!", -1))
const _hoisted_2 = { class: "code-blocks" }
const _hoisted_3 = { id: "description" }



export default /*#__PURE__*/_defineComponent({
  props: {
  description: {
    type: String,
    required: true,
    default: ''
  }
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("p", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(props.description), 1),
      _renderSlot(_ctx.$slots, "my-code", {
        id: "my-code",
        style: "text-decoration: underline"
      })
    ])
  ], 64))
}
}

})